import api from '../utils/api';
import {
  INVENTORY_TOTAL_VALUE_REQUEST,
  INVENTORY_TOTAL_VALUE_SUCCESS,
  INVENTORY_TOTAL_VALUE_FAIL,
  INVENTORY_TRANSACTION_REQUEST,
  INVENTORY_TRANSACTION_SUCCESS,
  INVENTORY_TRANSACTION_FAIL,
  INVENTORY_TRANSACTIONS_REQUEST,
  INVENTORY_TRANSACTIONS_SUCCESS,
  INVENTORY_TRANSACTIONS_FAIL,
  WAREHOUSE_LIST_REQUEST,
  WAREHOUSE_LIST_SUCCESS,
  WAREHOUSE_LIST_FAIL,
  INVENTORY_ALERTS_REQUEST,
  INVENTORY_ALERTS_SUCCESS,
  INVENTORY_ALERTS_FAIL,
  PRODUCT_INVENTORY_SUMMARY_REQUEST,
  PRODUCT_INVENTORY_SUMMARY_SUCCESS,
  PRODUCT_INVENTORY_SUMMARY_FAIL,
  WAREHOUSE_PRODUCT_DETAILS_REQUEST,
  WAREHOUSE_PRODUCT_DETAILS_SUCCESS,
  WAREHOUSE_PRODUCT_DETAILS_FAIL
} from '../constants/inventoryConstants';

// 获取库存总价值
export const fetchInventoryTotalValue = () => async (dispatch) => {
  try {
    dispatch({ type: INVENTORY_TOTAL_VALUE_REQUEST });
    
    const { data } = await api.get('/inventory/total-value');
    
    dispatch({
      type: INVENTORY_TOTAL_VALUE_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: INVENTORY_TOTAL_VALUE_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

// 创建入库交易
export const createInboundTransaction = (transaction) => async (dispatch) => {
  try {
    dispatch({ type: INVENTORY_TRANSACTION_REQUEST });
    
    const { data } = await api.post('/inventory/inbound', transaction);
    
    dispatch({
      type: INVENTORY_TRANSACTION_SUCCESS,
      payload: data
    });
    
    dispatch(fetchInventoryTotalValue());
    
    return data;
  } catch (error) {
    dispatch({
      type: INVENTORY_TRANSACTION_FAIL,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

// 修改现有的 createOutboundTransaction 函数名并更新
export const createSmartOutbound = (outboundData) => async (dispatch) => {
  try {
    dispatch({ type: INVENTORY_TRANSACTION_REQUEST });
    
    const { data } = await api.post('/inventory/outbound', outboundData);
    
    dispatch({
      type: INVENTORY_TRANSACTION_SUCCESS,
      payload: data
    });
    
    // 刷新库存数据
    dispatch(fetchInventoryTotalValue());
    
    return data;
  } catch (error) {
    dispatch({
      type: INVENTORY_TRANSACTION_FAIL,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

// 使用现有端点获取产品库存信息
export const getProductStockInfo = (product_id, warehouse_id = null) => async (dispatch) => {
  try {
    const params = warehouse_id ? `?warehouse_id=${warehouse_id}` : '';
    const { data } = await api.get(`/inventory/product/${product_id}/summary${params}`);
    return data;
  } catch (error) {
    console.error('获取库存信息失败:', error);
    throw error;
  }
};


// 获取交易记录
export const fetchInventoryTransactions = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: INVENTORY_TRANSACTIONS_REQUEST });
    
    const params = new URLSearchParams();
    if (filters.type) params.append('type', filters.type);
    if (filters.product_id) params.append('product_id', filters.product_id);
    if (filters.warehouse_id) params.append('warehouse_id', filters.warehouse_id);
    if (filters.operator) params.append('operator', filters.operator);
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    
    const { data } = await api.get(`/inventory/transactions?${params}`);
    
    dispatch({
      type: INVENTORY_TRANSACTIONS_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: INVENTORY_TRANSACTIONS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

// 获取仓库列表
export const fetchWarehouses = () => async (dispatch) => {
  try {
    dispatch({ type: WAREHOUSE_LIST_REQUEST });
    
    const { data } = await api.get('/inventory/warehouses');
    
    dispatch({
      type: WAREHOUSE_LIST_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: WAREHOUSE_LIST_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

// 获取库存预警
export const getInventoryAlerts = () => async (dispatch) => {
  try {
    dispatch({ type: INVENTORY_ALERTS_REQUEST });
    
    const { data } = await api.get('/inventory/alerts');
    
    dispatch({
      type: INVENTORY_ALERTS_SUCCESS,
      payload: data
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: INVENTORY_ALERTS_FAIL,
      payload: error.response?.data?.message || error.message
    });
    throw error;
  }
};

// 获取产品库存汇总（支持搜索）
export const fetchProductInventorySummary = (searchTerm = '') => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_INVENTORY_SUMMARY_REQUEST });
    
    const params = new URLSearchParams();
    if (searchTerm && searchTerm.trim()) {
      params.append('search', searchTerm.trim());
    }
    
    const { data } = await api.get(`/inventory/product-inventory-summary?${params}`);
    
    dispatch({
      type: PRODUCT_INVENTORY_SUMMARY_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_INVENTORY_SUMMARY_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

// 获取仓库产品详情
export const fetchWarehouseProductDetails = (warehouseId, searchTerm = '') => async (dispatch) => {
  try {
    dispatch({ type: 'WAREHOUSE_PRODUCT_DETAILS_REQUEST' });
    
    const params = new URLSearchParams();
    if (searchTerm && searchTerm.trim()) {
      params.append('search', searchTerm.trim());
    }
    
    const { data } = await api.get(`/inventory/warehouse/${warehouseId}/inventory-list?${params}`);
    
    dispatch({
      type: 'WAREHOUSE_PRODUCT_DETAILS_SUCCESS',
      payload: data
    });
  } catch (error) {
    dispatch({
      type: 'WAREHOUSE_PRODUCT_DETAILS_FAIL',
      payload: error.response?.data?.message || error.message
    });
  }
};

// 删除入库记录
export const deleteInboundRecord = (id) => async (dispatch) => {
  try {
    await api.delete(`/inventory/inbound/${id}`);
    
    // 刷新相关数据
    dispatch(fetchProductInventorySummary());
    dispatch(fetchInventoryTotalValue());
    
    return { success: true };
  } catch (error) {
    throw error.response?.data || error;
  }
};

// 删除出库记录
export const deleteOutboundRecord = (id) => async (dispatch) => {
  try {
    await api.delete(`/inventory/outbound/${id}`);
    
    // 刷新相关数据
    dispatch(fetchProductInventorySummary());
    dispatch(fetchInventoryTotalValue());
    
    return { success: true };
  } catch (error) {
    throw error.response?.data || error;
  }
};

// 删除仓库
export const deleteWarehouse = (id) => async (dispatch) => {
  try {
    await api.delete(`/inventory/warehouses/${id}`);
    
    // 刷新仓库列表
    dispatch(fetchWarehouses());
    dispatch(fetchInventoryTotalValue());
    
    return { success: true };
  } catch (error) {
    throw error.response?.data || error;
  }
};

